import { AmexIcon } from '@jfs/ui-new/src/assets/images/svgs/Amex'
import { CardIcon } from '@jfs/ui-new/src/assets/images/svgs/Card'
import { MaestroIcon } from '@jfs/ui-new/src/assets/images/svgs/Maestro'
import { MasterCardIcon } from '@jfs/ui-new/src/assets/images/svgs/MasterCard'
import { RupayIcon } from '@jfs/ui-new/src/assets/images/svgs/Rupay'
import { VisaIcon } from '@jfs/ui-new/src/assets/images/svgs/Visa'
import { Image } from 'react-native'
import { SodexoIcon } from '../../assets/images/svg/Sodexo'
//import { AmexIcon } from '../../assets/images/svg/Amex'
//import { CardIcon } from '../../assets/images/svg/Card'
//import { MaestroIcon } from '../../assets/images/svg/Maestro'
//import { MasterCardIcon } from '../../assets/images/svg/MasterCard'
//import { RupayIcon } from '../../assets/images/svg/Rupay'
//import { VisaIcon } from '../../assets/images/svg/Visa'
import { isIE } from '../../utils'

const renderCardIcon = (cardVendor: string | undefined, cardImage: string | undefined) => {
  console.log('cardImage', cardImage)
  if (isIE()) {
    switch (cardVendor) {
      case 'amex':
        return <Image style={styles.image} resizeMode="contain" source={require('../../assets/images/amex.png')} />
      case 'maestro':
        return (
          <Image style={styles.image} resizeMode="contain" source={require('../../assets/images/ic_cards_m.png')} />
        )
      case 'mastercard':
        return (
          <Image style={styles.image} resizeMode="contain" source={require('../../assets/images/ic_cards_mc.png')} />
        )
      case 'visa':
        return (
          <Image style={styles.image} resizeMode="contain" source={require('../../assets/images/ic_cards_v.png')} />
        )
      case 'rupay':
        return (
          <Image style={styles.image} resizeMode="contain" source={require('../../assets/images/ic_cards_rp.png')} />
        )

      case 'diners':
      case 'discover':
        return (
          <Image
            width={32}
            height={32}
            resizeMode="contain"
            source={require('../../assets/images/ic_cards_diner.png')}
          />
        )
      case 'sodexo':
        return <Image style={styles.image} resizeMode="contain" source={require('../../assets/images/sodexo.png')} />
      default:
        return <CardIcon width={32} height={32} color={'#d1e0ff'} />
    }
  } else {
    switch (cardVendor) {
      case 'amex':
        return <AmexIcon width={32} height={32} />
      case 'maestro':
        return <MaestroIcon width={30} height={30} />
      case 'mastercard':
        return <MasterCardIcon width={30} height={30} />
      case 'visa':
        return <VisaIcon width={32} height={32} />
      case 'rupay':
        return <RupayIcon width={30} height={30} />
      case 'diners':
      case 'discover':
        return (
          <Image style={styles.image} source={require('../../assets/images/ic_cards_diner.png')} resizeMode="center" />
        )
      case 'sodexo':
        return <SodexoIcon width={30} height={24} showBorder={true} />
      default:
        return <CardIcon width={30} height={30} color={'#d1e0ff'} />
    }
  }
}

const styles = { image: { width: 32, height: 32, marginTop: -5 } }
export { renderCardIcon }
